import { useContext } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Global } from '@emotion/react';
import { SidebarContext } from '../../contexts/SidebarContext';
// material ui components
import { Box, Drawer, Hidden, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
// sidebar components
import SidebarMenu from './Sidebar/SidebarMenu';
// icons
import Logo from '../../assets/icons/portrLogo.svg';
import { ReactComponent as CrossIcon } from '../../assets/icons/cross-icon.svg';

const SidebarWrapper = styled(Box)(
    ({ theme }) => `
        width: 174px;
        color: ${theme.palette.primary.main};
        background: ${theme.palette.white.main};
        height: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
          position: fixed;
          z-index: 10;
        }
`
);

const TopSection = styled(Box)(
    ({ theme }) => `
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 33px 0 41px 0;
`
);

const Cdrawer = styled(Drawer)(
    ({ theme }) => `
  .MuiPaper-root.MuiDrawer-paper {
    border-bottom-right-radius: 30px;
    border-top-right-radius: 30px;
  }
  `
);

const MobileTopSection = styled(Box)(
    ({ theme }) => `
        display: block;
        position: relative;
        width: 30px;
        height: 30px;
        margin: 16px 16px 16px auto;
`
);

function Sidebar() {
    const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
    const closeSidebar = () => toggleSidebar();

    return (
        <>
            <Hidden lgDown>
                <SidebarWrapper>
                    <Scrollbars autoHide>
                        <TopSection>
                            <img src={Logo} height='66px' alt='' />
                        </TopSection>
                        <SidebarMenu />
                    </Scrollbars>
                </SidebarWrapper>
            </Hidden>
            <Hidden lgUp>
                {sidebarToggle ? (
                    <Global
                        styles={{
                            '.MuiDrawer-root > .MuiPaper-root': {
                                height: '100%',
                                overflow: 'hidden',
                            },
                        }}
                    />
                ) : (
                    <Global
                        styles={{
                            '.MuiDrawer-root > .MuiPaper-root': {
                                height: `calc(94% - 42px)`,
                                overflow: 'visible',
                            },
                        }}
                    />
                )}
                <Cdrawer
                    anchor='left'
                    open={sidebarToggle}
                    onClose={closeSidebar}
                    variant='temporary'
                    elevation={9}
                    sx={{ borderTopRightRadius: '30px' }}
                >
                    <SidebarWrapper>
                        <Scrollbars autoHide>
                            <MobileTopSection>
                                <IconButton sx={{ p: 0 }} onClick={toggleSidebar}>
                                    <CrossIcon />
                                </IconButton>
                            </MobileTopSection>
                            <SidebarMenu />
                        </Scrollbars>
                    </SidebarWrapper>
                </Cdrawer>
            </Hidden>
        </>
    );
}

export default Sidebar;
